var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPopstar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Pop Star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 14",
    d: "M12 4L13.8063 7.63929L17.6569 6.34315L16.3607 10.1937L20 12L16.3607 13.8063L17.6569 17.6569L13.8063 16.3607L12 20L10.1937 16.3607L6.34315 17.6569L7.63929 13.8063L4 12L7.63929 10.1937L6.34315 6.34315L10.1937 7.63929L12 4Z",
    fill: "url(#paint0_linear_371_9233)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_371_9233",
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF813A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA43A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPopstar);
export default __webpack_public_path__ + "static/media/icon_popstar.62839cdd319b2818a93adbc76e12064d.svg";
export { ForwardRef as ReactComponent };